module.exports = __webpack_public_path__ + "static/img/baogaoxitong.829141b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/baogaoxitong.png
// module id = 2uB3
// module chunks = 1